import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { OktaService } from '../../shared/services/okta.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MfaGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _okta: OktaService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.checkMFAToken();
  }

  checkMFAToken(): Observable<boolean> {
    const token = this._okta.getMFAToken();
    if (!token || token === '' || token === null) {
      this._router.navigate(['/advisor/mfa']);
      return of(false); // Token not found or empty
    }
    const payload = {
      requestingSystem: 'FinPro',
      browserName: this._okta.getBrowserName(),
    };
    return this._okta.verifyMFAStatus(payload).pipe(
      map((response) => {
        return response && response.success ? true : (this._router.navigate(['/advisor/mfa']), false); // Handling success response for both the scenarios
      }),
      catchError((err) => {
        console.error('MFA verification failed:', err);
        if (err.status === 401) {
          this._router.parseUrl('/access-denied');
        } else if (err.status === 500) {
          this._router.navigate(['/server-error']);
        }
        this._router.navigate(['/advisor/mfa']);
        return of(false);
      }),
    );
  }
}
